import React from 'react';
import {useSelector} from "react-redux";
import {pipList, pipsLoading} from "./pipSearchSlice";
import {Spinner} from "@deere/ux.uxframe-react";
import {TextFilter, WtyReportTable} from "../common/wty-report-table/WtyReportTable";
import {languageResponseData} from "../Translation/translationSerachSlice";


const PipList = () => {
    const pips = useSelector(pipList);
    const pipLoading = useSelector(pipsLoading);

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };

    const pipColumns = React.useMemo(
        () => [
            {
                Header: translate('pip_number', 'PIP Number'),
                accessor: 'pipNumber',
                Filter: TextFilter,
            },
            {
                Header: translate('pip_type', 'PIP Type'),
                accessor: 'pipType',
                Filter: TextFilter,
            },
            {
                Header: translate('pip_participation_type', 'PIP Participation Type'),
                accessor: 'participant',
                Filter: TextFilter,
            },
            {
                Header: translate('pip_title', 'PIP Title'),
                accessor: 'pipTitle',
                Filter: TextFilter,
            },
            {
                Header: translate('pip_status', 'PIP Status'),
                accessor: 'status',
                Filter: TextFilter,
            }
        ],
        [translationsResponse]
    );
    return (
        <>
            {
                pipLoading ? (
                    <div className="uxf-spinner-border-inline mt-4">
                        <Spinner className="uxf-spinner-border-sm" animation="border"
                                 accessibilityLabel="Loading PIP information"/>
                        <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                            Loading PIP information...
                        </p>
                    </div>
                ) : (
                    <div>
                        {pips && Array.isArray(pips) && pips.length > 0 ? (
                            <WtyReportTable columns={pipColumns} data={pips}/>
                        ) : (
                            translate('message13', 'No PIP history found for the Product.')
                        )}
                    </div>
                )}
        </>
    );
};


export default PipList;